import { actionCreator } from 'utils';
import * as CarrierTypes from '../types/carrierTypes';

const initState = {
    loading: false,
    error: false,
    success: false,
    offset: 0,
    limit: 10,
    sort: {
        key: 'created_at',
        type: 'desc',
    },
    listing: {},
    add: {
        loading: false,
        error: false,
        success: false,
        current: 0,
    },
    edit: {
        loading: false,
        data: null,
        error: false,
        success: false,
    },
    filters: {
        name: '',
    },
};

export default function (state = initState, action) {
    switch (action.type) {
    case CarrierTypes.LOAD_CARRIERS:
        return Object.assign({}, state, {
            loading: true,
        });

    case actionCreator(CarrierTypes.LOAD_CARRIERS, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case actionCreator(CarrierTypes.LOAD_CARRIERS, 'err'):
        return Object.assign({}, state, {
            loading: false,
            error: true,
        });

    case CarrierTypes.SET_CARRIER_FILTER:
        return Object.assign({}, state, {
            loading: true,
            filters: {
                ...state.filters,
                [action.key]: action.value,
            },
        });

    case actionCreator(CarrierTypes.SET_CARRIER_FILTER, 'res'):
        return Object.assign({}, state, {
            loading: false,
            listing: action.data,
        });

    case CarrierTypes.SET_CARRIER_PAGINATION:
        return Object.assign({}, state, {
            [action.key]: action.pagination,
        });

    case CarrierTypes.SET_CARRIER_SORT:
        return Object.assign({}, state, {
            sort: action.sort,
        });

    case CarrierTypes.ADD_NEW_CARRIER:
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(CarrierTypes.ADD_NEW_CARRIER, 'res'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: action.loading,
                error: false,
                success: action.success,
            }),
        });

    case actionCreator(CarrierTypes.ADD_NEW_CARRIER, 'err'):
        return Object.assign({}, state, {
            add: Object.assign({}, state.add, {
                loading: false,
                error: action.error,
            }),
        });

    case CarrierTypes.LOAD_EDITABLE_CARRIER:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(CarrierTypes.LOAD_EDITABLE_CARRIER, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: action.data,
            }),
        });

    case actionCreator(CarrierTypes.LOAD_EDITABLE_CARRIER, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case CarrierTypes.EDIT_CARRIER:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: true,
                error: false,
            }),
        });

    case actionCreator(CarrierTypes.EDIT_CARRIER, 'res'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                success: action.success,
            }),
        });

    case actionCreator(CarrierTypes.EDIT_CARRIER, 'err'):
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                error: true,
            }),
        });

    case CarrierTypes.EDIT_CARRIER_FORM_PROPERTIES:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                data: {
                    ...state.edit.data,
                    properties: action.properties,
                },
            }),
        });

    case CarrierTypes.SET_EMPTY_EDITABLE_CARRIER:
        return Object.assign({}, state, {
            edit: Object.assign({}, state.edit, {
                loading: false,
                data: null,
                error: false,
            }),
        });

    default:
        return state;
    }
}
